import styled from 'styled-components'

export const Container = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  z-index: 9004;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  padding-bottom: 0;
  border-bottom: none;
`

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #262626;
    margin: 0;
  }
`

export const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const InfosContainer = styled.div`
  margin-bottom: 24px;
`

export const Section = styled.div`
  margin-bottom: 0;
  background: transparent;
  padding: 0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionDivider = styled.div`
  height: 1px;
  background-color: #F0F0F0;
  margin: 24px 0;
`

export const SectionSubtitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #262626;
  padding: 0;
`

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #262626;
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  background: transparent;
  padding: 0;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InfoLabel = styled.span`
  font-size: 12px;
  color: #8C8C8C;
  font-weight: 400;
`

export const InfoValue = styled.span`
  font-size: 14px;
  color: #262626;
  font-weight: 600;
`

export const SimpleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const SimpleTableRow = styled.tr`
  
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const TableHeader = styled.th`
  text-align: left;
  padding: 8px 12px;
  background-color: transparent;
  font-weight: 500;
  font-size: 12px;
  color: #8C8C8C;
  border-bottom: none;

  &:first-child {
    padding-left: 0;
  }
`

export const TableRow = styled.tr`
  
`

export const TableCell = styled.td`
  padding: 12px 12px;
  font-size: 14px;
  color: #262626;

  &:first-child {
    padding-left: 0;
  }
`

export const RowDatas = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
`

export const ButtonDiv = styled.button<{ variant?: 'primary' | 'secondary' | 'ghost' | 'outline' }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  border: none;
  white-space: nowrap;

  ${props => {
    switch(props.variant) {
      case 'primary':
        return `
          background-color: #00A8E8;
          color: white;
          &:disabled {
            background-color: #D9D9D9;
            color: #8C8C8C;
            cursor: not-allowed;
          }
        `
      case 'outline':
        return `
          background-color: white;
          color: #00A8E8;
          border: 1px solid #00A8E8;
          &:disabled {
            background-color: #FAFAFA;
            color: #D9D9D9;
            border-color: #D9D9D9;
            cursor: not-allowed;
          }
        `
      case 'ghost':
        return `
          background-color: transparent;
          color: #595959;
          border: 1px solid #D9D9D9;
          &:disabled {
            background-color: transparent;
            color: #D9D9D9;
            border-color: #D9D9D9;
            cursor: not-allowed;
          }
        `
      default:
        return `
          background-color: #F5F5F5;
          color: #262626;
          &:disabled {
            background-color: #FAFAFA;
            color: #D9D9D9;
            cursor: not-allowed;
          }
        `
    }
  }}

  img {
    width: 14px;
    height: 14px;
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9900;
`

export const ModalContent = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
`

export const ModalTitle = styled.h2`
  margin-bottom: 1rem;
  font-size: 1.25rem;
  color: #333;
  font-weight: 600;
`

export const ModalText = styled.p`
  margin-bottom: 2rem;
  color: #666;
  line-height: 1.5;
`

export const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`

export const ModalCancelButton = styled.button`
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ModalConfirmButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  background: #FF6B6B;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`